module.exports = __webpack_public_path__ + "img/zd-down-2.de28e73f.svg";